/* Prestige data layer v2 (GTM ecommerce events), TRACKING-CONTRACT.md v1 sections 2 to 4.
   Deferred asset (INP): all Liquid-dependent values come from window.ObDataLayerConfig (snippets/data-layer.liquid).

   Owners (contract section 4): this file owns view_item_list, select_item, view_item, search, add_to_cart,
   remove_from_cart, view_cart and the non-ecommerce events (contact_form_submit, newsletter_signup, phone_number_click,
   email_click, login, sign_up). It does NOT push begin_checkout / add_shipping_info / add_payment_info / purchase
   (the checkout pixel owns those) and it pushes NO personal data.

   FOR SUPER CHECKOUT (and any other script): the theme reports add_to_cart for ANY call to /cart/add or /cart/add.js made on
   the page through window.fetch or XMLHttpRequest, with only the added lines and the quantities that were requested.
   Do not push your own add_to_cart for such adds. Calls made with navigator.sendBeacon or from another window are not seen.
   Cart changes through /cart/change(.js), /cart/update(.js), /cart/clear(.js) are diffed against the last known cart and
   reported as add_to_cart (quantity up) or remove_from_cart (quantity down / line removed). Attribute-only updates report nothing.

   Item: item_id is the literal shopify_IN_{productId}_{variantId} (Merchant Center offer id); prices are rupees. */
(function() {
if (window.ObDataLayerLoaded) return;
window.ObDataLayerLoaded = true;

var ITEM_PREFIX = 'shopify_IN_';
var SEARCH_MIN = 2;

function round2(n) { return Math.round((Number(n) || 0) * 100) / 100; }
function str(v) { return v === undefined || v === null ? '' : String(v); }
function variantIdOf(line) { return line.variant_id !== undefined && line.variant_id !== null ? line.variant_id : line.id; }

// per-unit item level discount in cents
function unitDiscountCents(line) {
  if (line.unit_discount !== undefined) return Number(line.unit_discount) || 0;
  var q = Number(line.quantity) || 0;
  return line.total_discount && q ? Number(line.total_discount) / q : 0;
}

// internal line (Shopify cart-line shape, prices in cents) -> contract item (section 3, rupees)
function toItem(line, index) {
  var item = {
    item_id: ITEM_PREFIX + str(line.product_id) + '_' + str(variantIdOf(line)),
    item_name: line.product_title || line.title || ''
  };
  if (line.variant_title && line.variant_title !== 'Default Title') item.item_variant = line.variant_title;
  if (line.vendor) item.item_brand = line.vendor;
  if (line.product_type) item.item_category = line.product_type;
  item.price = round2((Number(line.final_price) || 0) / 100);
  item.quantity = Number(line.quantity) || 1;
  item.discount = round2(unitDiscountCents(line) / 100);
  item.index = index;
  if (line.item_list_id) item.item_list_id = str(line.item_list_id);
  if (line.item_list_name) item.item_list_name = line.item_list_name;
  item.product_id = str(line.product_id);
  item.variant_id = str(variantIdOf(line));
  if (line.sku) item.sku = line.sku;
  return item;
}

function normalizeCart(c) {
  c = c || {};
  var items = [];
  (c.items || []).forEach(function(l) { items.push(Object.assign({}, l)); });
  return { items: items, total_price: typeof c.total_price === 'number' ? c.total_price : null, currency: c.currency || 'INR' };
}

// ---- request parsing (what was asked to be added) ----
// returns [{id, quantity}] or null when the body cannot be read
function parseAddBody(body, url) {
  var out = [];
  function add(id, q) { if (id) out.push({ id: str(id), quantity: Math.max(1, parseInt(q, 10) || 1) }); }
  try {
    if (body && typeof body === 'object' && typeof body.entries === 'function' && !(body instanceof Array)) {
      // FormData or URLSearchParams
      var plain = {}, nested = {};
      body.forEach(function(value, key) {
        var m = /^items\[(\d+)\]\[(id|quantity)\]$/.exec(key);
        if (m) { (nested[m[1]] = nested[m[1]] || {})[m[2]] = value; } else if (key === 'id' || key === 'quantity') { plain[key] = value; }
      });
      var nk = Object.keys(nested);
      if (nk.length) { nk.sort(function(a, b) { return a - b; }).forEach(function(k) { add(nested[k].id, nested[k].quantity); }); return out.length ? out : null; }
      if (plain.id) { add(plain.id, plain.quantity); return out; }
      return null;
    }
    if (typeof body === 'string' && body) {
      if (body.charAt(0) === '{' || body.charAt(0) === '[') {
        var j = JSON.parse(body);
        if (j && Array.isArray(j.items)) j.items.forEach(function(i) { add(i.id, i.quantity); });
        else if (j && j.id) add(j.id, j.quantity);
        return out.length ? out : null;
      }
      return parseAddBody(new URLSearchParams(body), url);
    }
    if (url && url.indexOf('?') > -1) {
      var q = new URLSearchParams(url.split('?')[1].split('#')[0]);
      if (q.get('id')) { add(q.get('id'), q.get('quantity')); return out; }
    }
  } catch (e) {}
  return null;
}

// added lines with the quantities that were added (never the line total)
// req: [{id, quantity}] | null, resp: response line items, base: last known cart lines
function computeAdded(req, resp, base) {
  var added = [], used = {};
  resp.forEach(function(r, idx) {
    var vid = str(variantIdOf(r)), qty = null;
    if (req && req.length) {
      if (req.length === resp.length && req[idx].id === vid && !used[idx]) { qty = req[idx].quantity; used[idx] = 1; }
      else {
        for (var i = 0; i < req.length; i++) { if (!used[i] && req[i].id === vid) { qty = req[i].quantity; used[i] = 1; break; } }
      }
    }
    if (qty === null) {
      var before = 0;
      (base || []).forEach(function(b) { if (r.key && b.key === r.key) before = Number(b.quantity) || 0; });
      qty = (Number(r.quantity) || 0) - before;
      if (qty <= 0) qty = Number(r.quantity) || 0;
    }
    qty = Number(qty) || 0;
    if (qty <= 0) return;
    var line = Object.assign({}, r);
    line.unit_discount = unitDiscountCents(r);   // per unit, computed on the quantity the response reports
    line.quantity = qty;
    added.push(line);
  });
  return added;
}

// cart before/after -> lines to report
function diffCarts(oldItems, newItems) {
  var added = [], removed = [], oldMap = {}, newMap = {};
  oldItems.forEach(function(l) { oldMap[l.key || ('v' + variantIdOf(l))] = l; });
  newItems.forEach(function(l) { newMap[l.key || ('v' + variantIdOf(l))] = l; });
  Object.keys(newMap).forEach(function(k) {
    var n = newMap[k], o = oldMap[k], nq = Number(n.quantity) || 0, oq = o ? Number(o.quantity) || 0 : 0;
    if (nq > oq) { var l = Object.assign({}, n); l.unit_discount = unitDiscountCents(n); l.quantity = nq - oq; added.push(l); }
    else if (nq < oq) { var r = Object.assign({}, o); r.unit_discount = unitDiscountCents(o); r.quantity = oq - nq; removed.push(r); }
  });
  Object.keys(oldMap).forEach(function(k) {
    if (!newMap[k]) { var r = Object.assign({}, oldMap[k]); r.unit_discount = unitDiscountCents(oldMap[k]); removed.push(r); }
  });
  return { added: added, removed: removed };
}

// local cart after adding lines (keeps the baseline right without waiting for /cart.js)
function mergeAdded(items, added) {
  added.forEach(function(a) {
    var hit = null;
    items.forEach(function(b) { if (!hit && a.key && b.key === a.key) hit = b; });
    if (hit) hit.quantity = (Number(hit.quantity) || 0) + a.quantity;
    else items.push(Object.assign({}, a));
  });
  return items;
}

function handleOf(url) {
  var m = /\/products\/([^/?#]+)/.exec(str(url));
  return m ? m[1].toLowerCase() : '';
}

class ObDataLayer {
  constructor(config) {
    this.config = config || {};
    window.dataLayer = window.dataLayer || [];
    // INP: pushes that may be deferred wait here (see pushJob / flushPending)
    this.pending = [];
    this.flushScheduled = false;
    // INP: one delegated document listener per event type (see delegate)
    this.delegates = {};

    // lines with these product types are never reported in add_to_cart / remove_from_cart (gift lines added by scripts)
    this.ignoreProductTypes = ['free gift'];
    this.debug = false;
    try { this.debug = !!window.ObDataLayerDebug || /[?&]trk_debug=1/.test(location.search) || sessionStorage.getItem('trk_debug') === '1'; } catch (e) {}

    this.nativeFetch = window.fetch ? window.fetch.bind(window) : null;
    this.cart = normalizeCart(this.config.cart);
    this.currency = this.cart.currency || 'INR';
    this.cartVersion = 0;
    this.lastSearchTerm = '';
    this.searchTimer = null;
    this.lastViewedVariant = null;
    this.listItems = [];

    // INP safety net: a deferred push is never lost when the tab is hidden or the page is left
    window.addEventListener('pagehide', () => this.flushPending());
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') this.flushPending();
    });
    this.collectData();
  }

  eventConsole(eventName, eventData) {
    if (!this.debug) return;
    const css1 = 'background: red; color: #fff; font-size: normal; border-radius: 3px 0 0 3px; padding: 3px 4px;';
    const css2 = 'background-color: blue; color: #fff; font-size: normal; border-radius: 0 3px 3px 0; padding: 3px 4px;';
    console.log('%cGTM DataLayer Event:%c' + eventName, css1, css2, eventData);
  }

  collectData() {
    this.processPendingAdd();
    this.ajaxRequestData();
    this.nonAjaxAddData();
    this.cartDrawerData();

    const t = this.config.template || {};
    if (t.cart) this.viewCartPageData();
    if (t.product && this.config.product) this.productSinglePage();
    if (t.collection && this.config.collection) this.collectionsPageData();
    if (t.search && this.config.search) this.searchPageData();

    this.selectItemData();
    this.formData();
    this.phoneClickData();
    this.emailClickData();
    this.loginRegisterData();
  }

  isIgnored(line) {
    const t = str(line.product_type).toLowerCase();
    return !!t && this.ignoreProductTypes.indexOf(t) > -1;
  }

  // ---------- cart baseline ----------
  setCart(c) { this.cart = normalizeCart(c); this.cartVersion++; }

  refreshCart() {
    if (!this.nativeFetch) return;
    const version = this.cartVersion;
    this.nativeFetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then((r) => r.json())
      .then((data) => { if (version === this.cartVersion) this.cart = normalizeCart(data); })   // ignore a stale answer
      .catch(function() {});
  }

  // ---------- add_to_cart / remove_from_cart / search from network calls ----------
  classify(url) {
    let path = '', search = '';
    try { const u = new URL(url, location.href); path = u.pathname; search = u.search; } catch (e) { return null; }
    if (/\/cart\/add(\.js|\.json)?$/.test(path)) return { kind: 'add' };
    if (/\/cart\/(change|update|clear)(\.js|\.json)?$/.test(path)) return { kind: 'change' };
    if (/\/search(\/suggest)?(\.json)?$/.test(path)) {
      const q = new URLSearchParams(search);
      if (q.get('q') && (path.indexOf('/suggest') > -1 || q.get('section_id') === 'predictive-search')) return { kind: 'search', term: q.get('q') };
    }
    return null;
  }

  // info: {kind, term}, request: parsed [{id,quantity}] | null, json: parsed response body
  onNetwork(info, req, json) {
    if (info.kind === 'add') this.onCartAdd(req, json);
    else if (info.kind === 'change') this.onCartChange(json);
  }

  onCartAdd(req, json) {
    if (!json) return;
    const respItems = Array.isArray(json.items) ? json.items : ((json.variant_id || json.id) ? [json] : []);
    if (!respItems.length) return;
    const added = computeAdded(req, respItems, this.cart.items);
    const reportable = added.filter((l) => !this.isIgnored(l));
    if (reportable.length) this.ecommerceDataLayer('add_to_cart', reportable);
    mergeAdded(this.cart.items, added);
    this.cartVersion++;
    this.refreshCart();
  }

  onCartChange(json) {
    if (!json || !Array.isArray(json.items)) return;
    const next = normalizeCart(json);
    const d = diffCarts(this.cart.items, next.items);
    const add = d.added.filter((l) => !this.isIgnored(l)), rem = d.removed.filter((l) => !this.isIgnored(l));
    this.cart = next; this.cartVersion++;
    if (add.length) this.ecommerceDataLayer('add_to_cart', add);
    if (rem.length) this.ecommerceDataLayer('remove_from_cart', rem);
  }

  onSearchTerm(term) {
    term = str(term).trim();
    if (term.length < SEARCH_MIN || term === this.lastSearchTerm) return;
    clearTimeout(this.searchTimer);
    // predictive search fires a request per keystroke: report once the visitor pauses
    this.searchTimer = setTimeout(() => {
      if (term === this.lastSearchTerm) return;
      this.lastSearchTerm = term;
      this.searchEvent(term, []);
    }, 800);
  }

  ajaxRequestData() {
    const self = this;
    const origFetch = window.fetch;
    if (origFetch) {
      window.fetch = function(input, init) {
        const p = origFetch.apply(window, arguments);
        try {
          const url = typeof input === 'string' ? input : (input && input.url) ? input.url : str(input);
          const info = self.classify(url);
          if (info) {
            const method = str((init && init.method) || (input && input.method) || 'GET').toUpperCase();
            const req = info.kind === 'add' ? parseAddBody(init && init.body, url) : null;
            if (info.kind === 'search') { if (method === 'GET') p.then((res) => { if (res && res.ok) self.onSearchTerm(info.term); }, function() {}); }
            else if (method !== 'GET') {
              p.then((res) => {
                if (!res || !res.ok) return;
                res.clone().json().then((json) => { try { self.onNetwork(info, req, json); } catch (e) { setTimeout(function() { throw e; }); } }, function() {});
              }, function() {});
            }
          }
        } catch (e) {}
        return p;
      };
    }

    const XP = window.XMLHttpRequest && window.XMLHttpRequest.prototype;
    if (XP) {
      const origOpen = XP.open, origSend = XP.send;
      XP.open = function(method, url) {
        try { this.__obUrl = str(url); this.__obMethod = str(method).toUpperCase(); } catch (e) {}
        return origOpen.apply(this, arguments);
      };
      XP.send = function(body) {
        try {
          const xhr = this, info = xhr.__obUrl ? self.classify(xhr.__obUrl) : null;
          if (info) {
            const req = info.kind === 'add' ? parseAddBody(body, xhr.__obUrl) : null;
            xhr.addEventListener('load', function() {
              try {
                if (xhr.status < 200 || xhr.status >= 300) return;
                if (info.kind === 'search') { if (xhr.__obMethod === 'GET') self.onSearchTerm(info.term); return; }
                if (xhr.__obMethod === 'GET') return;
                self.onNetwork(info, req, xhr.responseType === 'json' ? xhr.response : JSON.parse(xhr.responseText));
              } catch (e) {}
            });
          }
        } catch (e) {}
        return origSend.apply(this, arguments);
      };
    }
  }

  // classic (non ajax) form post to /cart/add: the page navigates, so remember the add and report it on the next page
  nonAjaxAddData() {
    document.addEventListener('submit', (event) => {
      try {
        if (event.defaultPrevented) return;   // the theme's product-form handles the submit by ajax and prevents default
        const f = event.target;
        if (!f || !f.getAttribute || !/\/cart\/add/.test(str(f.getAttribute('action')))) return;
        const req = parseAddBody(new FormData(f));
        if (req && req.length) sessionStorage.setItem('ob_dl_pending_add', JSON.stringify({ items: req, ts: Date.now() }));
      } catch (e) {}
    });
  }

  processPendingAdd() {
    try {
      const raw = sessionStorage.getItem('ob_dl_pending_add');
      if (!raw) return;
      sessionStorage.removeItem('ob_dl_pending_add');
      const p = JSON.parse(raw);
      if (!p || !p.items || Date.now() - p.ts > 60000) return;
      const lines = [];
      p.items.forEach((it) => {
        this.cart.items.forEach((l) => {
          if (str(variantIdOf(l)) === it.id && !lines.some(function(x) { return x.key === l.key; })) {
            const c = Object.assign({}, l); c.unit_discount = unitDiscountCents(l); c.quantity = it.quantity; lines.push(c);
          }
        });
      });
      const reportable = lines.filter((l) => !this.isIgnored(l));
      if (reportable.length) this.ecommerceDataLayer('add_to_cart', reportable);
    } catch (e) {}
  }

  // ---------- view_cart ----------
  viewCart() {
    const lines = this.cart.items.filter((l) => !this.isIgnored(l));
    if (!lines.length) return;
    const whole = lines.length === this.cart.items.length && this.cart.total_price !== null;
    this.ecommerceDataLayer('view_cart', lines, whole ? { value: round2(this.cart.total_price / 100) } : undefined);
  }

  viewCartPageData() { this.viewCart(); }

  // cart drawer opened (theme: <cart-drawer id="cart-drawer"> fires dialog:after-show on itself, not bubbling)
  cartDrawerData() {
    document.addEventListener('dialog:after-show', (event) => {
      const t = event.target;
      if (t && t.tagName === 'CART-DRAWER') this.viewCart();
    }, true);
  }

  // ---------- product page: view_item (page load and variant change) ----------
  productVariantLine(variantId) {
    const p = this.config.product;
    let v = null;
    p.variants.forEach(function(x) { if (str(x.id) === str(variantId)) v = x; });
    if (!v) return null;
    return {
      product_id: p.id, variant_id: v.id, product_title: p.title, variant_title: v.title, vendor: p.vendor,
      product_type: p.type, sku: v.sku, final_price: v.price, quantity: 1,
      item_list_id: p.listId, item_list_name: p.listName
    };
  }

  // Buy it now goes to a cart permalink (no /cart/add call is made, so the network hook cannot see it): trk-attribution calls this
  // once, right before navigating. Returns true when the event was pushed (variant known from the product page config).
  reportPermalinkAdd(variantId, quantity) {
    try {
      const line = this.config.product ? this.productVariantLine(variantId) : null;
      if (!line || this.isIgnored(line)) return false;
      line.quantity = Math.max(1, parseInt(quantity, 10) || 1);
      this.ecommerceDataLayer('add_to_cart', [line]);
      return true;
    } catch (e) { return false; }
  }

  viewItem(variantId, variantPriceCents, deferPush) {
    if (this.lastViewedVariant === str(variantId)) return;
    const line = this.productVariantLine(variantId);
    if (!line) return;
    if (variantPriceCents !== undefined && variantPriceCents !== null) line.final_price = variantPriceCents;
    this.lastViewedVariant = str(variantId);
    this.ecommerceDataLayer('view_item', [line], undefined, deferPush);
  }

  productSinglePage() {
    this.viewItem(this.config.product.variantId);
    // variant picked: view_item for the new variant. The theme's variant:change event only carries {formId, variant, previousVariant}.
    const ids = this.config.product.variants.map(function(v) { return str(v.id); });
    document.addEventListener('variant:change', (event) => {
      const variant = event.detail && event.detail.variant;
      if (!variant || !variant.id || ids.indexOf(str(variant.id)) === -1) return;
      // deferred push (INP): a variant tap does not navigate; the payload is built now, only the dataLayer.push waits one frame
      this.viewItem(variant.id, typeof variant.price === 'number' ? variant.price : undefined, true);
    });
  }

  // ---------- lists ----------
  // items rendered by Liquid that are also visible in the grid (handles page 2+ and filters), in page order
  visibleListItems(items) {
    const root = document.querySelector('main') || document;
    const links = root.querySelectorAll('a[href*="/products/"]');
    if (!links.length) return items;
    const byHandle = {}, seen = {}, out = [];
    items.forEach(function(it) { const h = handleOf(it.url); if (h) byHandle[h] = it; });
    for (let i = 0; i < links.length; i++) {
      const h = handleOf(links[i].getAttribute('href'));
      if (h && !seen[h] && byHandle[h]) { seen[h] = 1; out.push(byHandle[h]); }
    }
    return out;
  }

  collectionsPageData() {
    const c = this.config.collection;
    const items = this.visibleListItems(c.items || []);
    this.listItems = items;
    if (!items.length) return;
    this.ecommerceDataLayer('view_item_list', items, { item_list_id: str(c.id), item_list_name: c.title });
  }

  searchPageData() {
    const s = this.config.search;
    const term = str(s.terms).trim();
    if (!term) return;
    const all = (s.items || []).map(function(it) { return Object.assign({ item_list_id: 'search', item_list_name: 'Search results' }, it); });
    this.listItems = this.visibleListItems(all);
    this.lastSearchTerm = term;
    this.searchEvent(term, this.listItems);
  }

  searchEvent(term, lines) {
    if (lines && lines.length) { this.ecommerceDataLayer('search', lines, { search_term: term }); return; }
    this.pushNow({ event: 'search', search_term: term });
    this.eventConsole('search', { search_term: term });
  }

  // select_item: a product link in a list was clicked
  selectItemData() {
    if (!(this.config.template && (this.config.template.collection || this.config.template.search))) return;
    // click, not pointerdown: a touch scroll starts with pointerdown and must not count as a selection.
    // sync push on purpose: the click is a link that navigates to the product page
    this.delegate('click', 'a[href*="/products/"]', (event) => {
      const link = event.target.closest('a[href*="/products/"]');
      if (!link) return;
      const h = handleOf(link.getAttribute('href'));
      if (!h) return;
      for (let i = 0; i < this.listItems.length; i++) {
        const it = this.listItems[i];
        if (handleOf(it.url) === h) {
          this.ecommerceDataLayer('select_item', [it], { item_list_id: str(it.item_list_id), item_list_name: it.item_list_name });
          return;
        }
      }
    });
  }

  // ---------- the one place that builds and pushes an ecommerce event ----------
  // lines: internal lines (cents); extra: {value (rupees), item_list_id, item_list_name, search_term}
  buildEcommerceEvent(event, lines, extra) {
    extra = extra || {};
    const items = lines.map(function(l, i) { return toItem(l, l.index !== undefined && l.index !== null ? l.index : i); });
    const ecommerce = { currency: this.currency };
    ecommerce.value = extra.value !== undefined ? extra.value : round2(items.reduce(function(t, it) { return t + it.price * it.quantity; }, 0));
    if (extra.item_list_id) ecommerce.item_list_id = extra.item_list_id;
    if (extra.item_list_name) ecommerce.item_list_name = extra.item_list_name;
    ecommerce.items = items;
    const data = { event: event, ecommerce: ecommerce };
    if (extra.search_term) data.search_term = extra.search_term;
    return data;
  }

  // deferPush=true (only view_item on variant change): the payload is still built right now, only the dataLayer.push waits.
  ecommerceDataLayer(event, lines, extra, deferPush) {
    const self = this;
    let data = null;
    try { data = this.buildEcommerceEvent(event, lines, extra); } catch (e) { setTimeout(function() { throw e; }); return; }
    this.pushJob(function() {
      dataLayer.push({ ecommerce: null });   // contract rule 8: clear before every ecommerce push
      dataLayer.push(data);
      self.eventConsole(event, data);
    }, deferPush);
  }

  // INP: run a dataLayer push job. Sync (default): anything still queued goes first so the order never changes, then the job runs now.
  // Deferred: the job waits for the next frame (rAF + timeout, with a fallback timer); it is also flushed when the page is hidden/unloaded.
  pushJob(job, deferPush) {
    if (!deferPush) {
      this.flushPending();
      job();
      return;
    }
    this.pending.push(job);
    this.scheduleFlush();
  }

  scheduleFlush() {
    if (this.flushScheduled) return;
    this.flushScheduled = true;
    const run = () => this.flushPending();
    if (typeof requestAnimationFrame === 'function') {
      requestAnimationFrame(() => setTimeout(run, 0));
    }
    setTimeout(run, 150);
  }

  flushPending() {
    this.flushScheduled = false;
    while (this.pending.length) {
      const job = this.pending.shift();
      try { job(); } catch (error) { setTimeout(function() { throw error; }); }
    }
  }

  // sync dataLayer.push for events that are not ecommerce events
  pushNow(obj) {
    this.flushPending();
    dataLayer.push(obj);
  }

  // INP: one delegated document listener per event type. Handlers run in registration order, each with its own checks.
  // The combined selector is only a cheap early exit.
  delegate(type, selector, handler) {
    let d = this.delegates[type];
    if (!d) {
      d = this.delegates[type] = { list: [], selectors: [], combined: '' };
      document.addEventListener(type, (event) => this.dispatch(type, event));
    }
    d.list.push(handler);
    if (selector) d.selectors.push(selector);
    d.combined = d.selectors.join(', ');
    // a handler without a selector can never be skipped
    if (!selector) d.always = true;
  }

  dispatch(type, event) {
    const d = this.delegates[type];
    if (!d.always) {
      const t = event.target;
      if (!t || typeof t.closest !== 'function') return;
      try { if (!t.closest(d.combined)) return; } catch (error) { /* bad selector: run every handler */ }
    }
    for (let i = 0; i < d.list.length; i++) {
      try { d.list[i](event); } catch (error) { setTimeout(function() { throw error; }); }
    }
  }

  // ---------- non-ecommerce events (no field values: contract rule 7, no personal data) ----------
  formData() {
    const self = this;
    // sync pushes on purpose: a contact / newsletter post navigates away
    this.delegate('submit', 'form[action^="/contact"]', function(event) {
      const targetForm = event.target.closest('form[action^="/contact"]');
      if (!targetForm) return;
      const data = {
        form_location: window.location.href,
        form_id: targetForm.getAttribute('id'),
        form_classes: targetForm.getAttribute('class')
      };
      const formType = targetForm.querySelector('input[name="form_type"]');
      if (formType && formType.value === 'customer') {
        self.pushNow(Object.assign({ event: 'newsletter_signup' }, data));
        self.eventConsole('newsletter_signup', data);
      } else if (formType && formType.value === 'contact') {
        self.pushNow(Object.assign({ event: 'contact_form_submit' }, data));
        self.eventConsole('contact_form_submit', data);
      }
    });
  }

  phoneClickData() {
    const self = this;
    this.delegate('click', 'a[href^="tel:"]', function(event) {
      const target = event.target.closest('a[href^="tel:"]');
      if (!target) return;
      const eventData = {
        event: 'phone_number_click',
        page_location: window.location.href,
        link_classes: target.getAttribute('class'),
        link_id: target.getAttribute('id'),
        phone_number: target.getAttribute('href').replace('tel:', '')
      };
      self.pushNow(eventData);
      self.eventConsole('phone_number_click', eventData);
    });
  }

  emailClickData() {
    const self = this;
    this.delegate('click', 'a[href^="mailto:"]', function(event) {
      const target = event.target.closest('a[href^="mailto:"]');
      if (!target) return;
      const eventData = {
        event: 'email_click',
        page_location: window.location.href,
        link_classes: target.getAttribute('class'),
        link_id: target.getAttribute('id'),
        email_address: target.getAttribute('href').replace('mailto:', '')
      };
      self.pushNow(eventData);
      self.eventConsole('email_click', eventData);
    });
  }

  loginRegisterData() {
    const self = this;
    let isTrackedLogin = false, isTrackedRegister = false;

    if (window.location.href.includes('/account/login')) {
      this.delegate('submit', '[action="/account/login"]', function(e) {
        if (e.target.closest('[action="/account/login"]') && !isTrackedLogin) {
          isTrackedLogin = true;
          self.pushNow({ event: 'login' });
          self.eventConsole('login', {});
        }
      });
    }
    if (window.location.href.includes('/account/register')) {
      this.delegate('submit', '[action="/account"]', function(e) {
        if (e.target.closest('[action="/account"]') && !isTrackedRegister) {
          isTrackedRegister = true;
          self.pushNow({ event: 'sign_up' });
          self.eventConsole('sign_up', {});
        }
      });
    }
  }
}
// end ObDataLayer

if (window.ObDataLayerExpose) window.ObDataLayerInternals = { ObDataLayer: ObDataLayer, toItem: toItem, parseAddBody: parseAddBody, computeAdded: computeAdded, diffCarts: diffCarts, mergeAdded: mergeAdded, normalizeCart: normalizeCart, handleOf: handleOf };

// Start exactly where the inline version started: on DOMContentLoaded. The inline stub in snippets/data-layer.liquid registers that
// listener in <head> and sets window.ObDataLayerDom; deferred scripts run before DOMContentLoaded, so ObDataLayerStart already
// exists when the stub's listener fires. If this file ever loads after DOMContentLoaded it starts at once.
var started = false;
function start() {
  if (started) return;
  started = true;
  try {
    window.ObDataLayerInstance = new ObDataLayer(window.ObDataLayerConfig);
  } catch (error) {
    console.log(error);
  }
}
window.ObDataLayerStart = start;
if (window.ObDataLayerDom || document.readyState === 'complete') {
  start();
}
})();
